import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { KpiCardComponent } from '../../components/kpi-card/kpi-card.component';
import { TestmoduleStatsCardComponent } from '../testmodule-stats/testmodule-stats.component';
import { TestschritteStatsCardComponent } from '../testschritte-stats/testschritte-stats.component';
import { Qualitaet } from '../../models/dashboard.model';

@Component({
  selector: 'app-qualitaet-section',
  imports: [TranslatePipe, KpiCardComponent, TestmoduleStatsCardComponent, TestschritteStatsCardComponent],
  templateUrl: './quality.component.html',
  styleUrl: './quality.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QualitaetSectionComponent {
  qualitaet = input.required<Qualitaet>();

  private readonly translate = inject(TranslateService);
  private readonly currentLang = toSignal(this.translate.onLangChange.pipe(map((e) => e.lang)), {
    initialValue: this.translate.currentLang,
  });

  protected readonly coverageValue = computed(() => this.formatTrimmed(this.qualitaet().anforderungsAbdeckung.value));
  protected readonly automationValue = computed(() => this.formatTrimmed(this.qualitaet().automatisierungsQuote.value));
  protected readonly reuseValue = computed(() => this.formatOneDecimal(this.qualitaet().wiederverwendungsGrad.value));

  private formatTrimmed(value: number): string {
    return Number.isInteger(value) ? this.formatNumber(value, 0) : this.formatOneDecimal(value);
  }

  private formatOneDecimal(value: number): string {
    return this.formatNumber(value, 1);
  }

  private formatNumber(value: number, fractionDigits: number): string {
    return new Intl.NumberFormat(this.currentLang() || 'de', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(value);
  }
}
